import { getAuth, onIdTokenChanged } from "firebase/auth";
import { FirebaseError } from "firebase/app";
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";

export default function useUserIdToken() {
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const unsub = onIdTokenChanged(getAuth(), (user) =>
      user
        ?.getIdToken()
        .then((token) => setAccessToken(token))
        .catch((error) => {
          // Same policy as the anon sign-in retry loop: transient network
          // failures go to Sentry Logs, everything else is a real issue.
          if (
            error instanceof FirebaseError &&
            error.code === "auth/network-request-failed"
          ) {
            Sentry.logger.warn("Token refresh network failure", {
              online: navigator.onLine,
            });
            return;
          }
          Sentry.captureException(error);
        }),
    );

    return () => unsub();
  }, []);

  return accessToken;
}
